import { EVENTS } from '../constants/webSocketConsts/events';
import { SetPaymentInfo } from '../store/payments/actions';

const paymentHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.MODIFY:
      if (items.length === 0) {
        break;
      }
      return SetPaymentInfo(items[0]);
    default:
      break;
  }
  return null;
};

export default paymentHandler;
